import axios from 'axios';

import {getCookie} from './cookie';
import {SERVER_URL} from './url';

const client = axios.create({
    baseURL: SERVER_URL
    // baseURL: 'https://women.dfinite.ai'
});

client.interceptors.request.use(
    (config) => {
        const accessToken = getCookie('accessToken');

        config.headers["Content-Type"] = "application/json";
        config.headers["Authorization"] = `Bearer ${accessToken}`;

        return config;
    },
    (error) => {
        console.log('interceptor 에러: ', error);
        return Promise.reject(error);
    }
);

export default client;
